
import { Options, Vue } from "vue-class-component";
import InlineSvg from "vue-inline-svg";

@Options({
  name: "SvgImage",
  components: {
    InlineSvg
  },
  props: {
    src: {
      type: String,
    },
    global: {
      type: Boolean,
      default: false,
    },
  },
})
export default class SvgImage extends Vue {
  private basePath: string = process.env.VUE_APP_RESOURCE_URL;
  private src!: string;
  private isLoaded = false;
  private global!: boolean;
  private isError = false;

  get getPath(): string {
    if (this.global) {
      if (this.isError) {
        return require(`@/assets/images/icons/broken-image.svg`);
      }

      return `${this.basePath}/${this.src}`;
    }

    try {
      return require(`@/assets/images/${this.src}`);
    } catch (e) {
      return require(`@/assets/images/icons/broken-image.svg`);
    }
  }

  private onImageLoad(): void {
    this.isLoaded = true;
  }

  private onImageLoadError(): void {
    this.isError = true;
  }
}
